// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_intraday_market_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_intraday_market_model.proto.
 */
export const file_bffuser_v1_bidding_intraday_market_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_side, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * 板の売買 1 行 (BFF mirror)。
 *
 * @generated from message bffuser.v1.BiddingMarketBid
 */
export type BiddingMarketBid = Message<"bffuser.v1.BiddingMarketBid"> & {
  /**
   * @generated from field: bffuser.v1.BiddingIntradayMarketAreaGroup area_group = 1;
   */
  areaGroup: BiddingIntradayMarketAreaGroup;

  /**
   * 売/買 区分。
   *
   * @generated from field: bfftypes.v1.Side side = 2;
   */
  side: Side;

  /**
   * 価格 (円/kWh)。
   *
   * @generated from field: google.type.Decimal price = 3;
   */
  price?: Decimal;

  /**
   * 量 (MW)。
   *
   * @generated from field: google.type.Decimal volume = 4;
   */
  volume?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingMarketBid.
 * Use `create(BiddingMarketBidSchema)` to create a new message.
 */
export const BiddingMarketBidSchema: GenMessage<BiddingMarketBid> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_model, 0);

/**
 * 板 (= 1 コマ分の注文一覧, BFF mirror)。
 * 市場データは全社共通のため organization_id を持たない。
 *
 * @generated from message bffuser.v1.BiddingMarketOrderBook
 */
export type BiddingMarketOrderBook = Message<"bffuser.v1.BiddingMarketOrderBook"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;

  /**
   * 板の売買行。
   *
   * @generated from field: repeated bffuser.v1.BiddingMarketBid bids = 3;
   */
  bids: BiddingMarketBid[];

  /**
   * 全売 volume 合計 (MW)。
   *
   * @generated from field: google.type.Decimal total_sell_volume = 4;
   */
  totalSellVolume?: Decimal;

  /**
   * 全買 volume 合計 (MW)。
   *
   * @generated from field: google.type.Decimal total_buy_volume = 5;
   */
  totalBuyVolume?: Decimal;

  /**
   * 中央値価格 (円/kWh)。 板が空の場合は unset。
   *
   * @generated from field: optional google.type.Decimal median_price = 6;
   */
  medianPrice?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingMarketOrderBook.
 * Use `create(BiddingMarketOrderBookSchema)` to create a new message.
 */
export const BiddingMarketOrderBookSchema: GenMessage<BiddingMarketOrderBook> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_model, 1);

/**
 * 連系線 1 本の容量 (BFF mirror)。
 *
 * @generated from message bffuser.v1.BiddingInterconnectionCapacity
 */
export type BiddingInterconnectionCapacity = Message<"bffuser.v1.BiddingInterconnectionCapacity"> & {
  /**
   * 連系線名 (例: "北海道_東北")。
   *
   * @generated from field: string line_name = 1;
   */
  lineName: string;

  /**
   * 順方向容量 (MW)。
   *
   * @generated from field: google.type.Decimal forward_mw = 2;
   */
  forwardMw?: Decimal;

  /**
   * 逆方向容量 (MW)。
   *
   * @generated from field: google.type.Decimal reverse_mw = 3;
   */
  reverseMw?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingInterconnectionCapacity.
 * Use `create(BiddingInterconnectionCapacitySchema)` to create a new message.
 */
export const BiddingInterconnectionCapacitySchema: GenMessage<BiddingInterconnectionCapacity> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_model, 2);

/**
 * 連系線容量一覧 (BFF mirror)。
 *
 * @generated from message bffuser.v1.BiddingInterconnectionCapacities
 */
export type BiddingInterconnectionCapacities = Message<"bffuser.v1.BiddingInterconnectionCapacities"> & {
  /**
   * 連系線 (北海道_東北 〜 中国_九州 の 10 本)。
   *
   * @generated from field: repeated bffuser.v1.BiddingInterconnectionCapacity lines = 1;
   */
  lines: BiddingInterconnectionCapacity[];

  /**
   * 最終更新日時。
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.BiddingInterconnectionCapacities.
 * Use `create(BiddingInterconnectionCapacitiesSchema)` to create a new message.
 */
export const BiddingInterconnectionCapacitiesSchema: GenMessage<BiddingInterconnectionCapacities> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_model, 3);

/**
 * ティッカー 1 約定 (BFF mirror)。
 *
 * @generated from message bffuser.v1.BiddingMarketContract
 */
export type BiddingMarketContract = Message<"bffuser.v1.BiddingMarketContract"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;

  /**
   * 約定日時。
   *
   * @generated from field: google.protobuf.Timestamp contracted_at = 3;
   */
  contractedAt?: Timestamp;

  /**
   * 約定価格 (円/kWh)。
   *
   * @generated from field: google.type.Decimal price = 4;
   */
  price?: Decimal;

  /**
   * 約定量 (MW)。
   *
   * @generated from field: google.type.Decimal volume = 5;
   */
  volume?: Decimal;

  /**
   * eSLJ が板情報との突合で推定した売りエリア・買いエリア・売買区分 (AC-BIN-031)。
   * 推定前と、 eSLJ から推定値を取得できない間は unset。
   *
   * @generated from field: bffuser.v1.BiddingMarketContractEstimation estimation = 6;
   */
  estimation?: BiddingMarketContractEstimation;
};

/**
 * Describes the message bffuser.v1.BiddingMarketContract.
 * Use `create(BiddingMarketContractSchema)` to create a new message.
 */
export const BiddingMarketContractSchema: GenMessage<BiddingMarketContract> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_model, 4);

/**
 * 約定 1 件の推定結果 (BFF mirror)。
 * backend `internalapi.v1.MarketContractEstimation` と 1:1 (field 番号も一致)。
 * 特定できなかった項目は unset。 推定済みで何も特定できなかった時は、 この message を設定したまま
 * 全項目を unset にする (message 自体が unset の「推定前」と区別する)。
 *
 * @generated from message bffuser.v1.BiddingMarketContractEstimation
 */
export type BiddingMarketContractEstimation = Message<"bffuser.v1.BiddingMarketContractEstimation"> & {
  /**
   * 売りエリア (推定)。
   *
   * @generated from field: optional bffuser.v1.BiddingIntradayMarketAreaGroup sell_area_group = 1;
   */
  sellAreaGroup?: BiddingIntradayMarketAreaGroup;

  /**
   * 買いエリア (推定)。
   *
   * @generated from field: optional bffuser.v1.BiddingIntradayMarketAreaGroup buy_area_group = 2;
   */
  buyAreaGroup?: BiddingIntradayMarketAreaGroup;

  /**
   * 売買区分 (推定)。 約定を仕掛けた側 (Paid = 買、 Given = 売)。
   *
   * @generated from field: optional bfftypes.v1.Side side = 3;
   */
  side?: Side;
};

/**
 * Describes the message bffuser.v1.BiddingMarketContractEstimation.
 * Use `create(BiddingMarketContractEstimationSchema)` to create a new message.
 */
export const BiddingMarketContractEstimationSchema: GenMessage<BiddingMarketContractEstimation> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_model, 5);

/**
 * コマ取引状態 (= ribbon status 1 コマ, BFF mirror)。
 *
 * @generated from message bffuser.v1.BiddingMarketProduct
 */
export type BiddingMarketProduct = Message<"bffuser.v1.BiddingMarketProduct"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;

  /**
   * 取引中断状態。
   *
   * @generated from field: bffuser.v1.BiddingIntradayMarketSuspenseState suspense_state = 3;
   */
  suspenseState: BiddingIntradayMarketSuspenseState;
};

/**
 * Describes the message bffuser.v1.BiddingMarketProduct.
 * Use `create(BiddingMarketProductSchema)` to create a new message.
 */
export const BiddingMarketProductSchema: GenMessage<BiddingMarketProduct> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_model, 6);

/**
 * コマ別 約定サマリ (= ribbon の約定件数 1 コマ, BFF mirror)。
 * backend `internalapi.v1.MarketContractSummary` と 1:1 (field 番号も一致)。
 *
 * @generated from message bffuser.v1.BiddingMarketContractSummary
 */
export type BiddingMarketContractSummary = Message<"bffuser.v1.BiddingMarketContractSummary"> & {
  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;

  /**
   * 約定件数 (= そのコマの成立約定の本数。 約定なしは 0)。
   *
   * @generated from field: int32 contract_count = 3;
   */
  contractCount: number;
};

/**
 * Describes the message bffuser.v1.BiddingMarketContractSummary.
 * Use `create(BiddingMarketContractSummarySchema)` to create a new message.
 */
export const BiddingMarketContractSummarySchema: GenMessage<BiddingMarketContractSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_intraday_market_model, 7);

/**
 * 時間前市場の板エリアグループ (BFF mirror)。
 * backend `internalapi.v1.IntradayMarketAreaGroup` と 1:1。
 * JEPX 時間前市場の 5 列エリア区分 (= 既存 AreaCode と粒度が異なるため独自定義)。
 * 市場データは全社共通 (= org 非依存) のため organization_id を持たない。
 *
 * @generated from enum bffuser.v1.BiddingIntradayMarketAreaGroup
 */
export enum BiddingIntradayMarketAreaGroup {
  /**
   * @generated from enum value: BIDDING_INTRADAY_MARKET_AREA_GROUP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 北海道。
   *
   * @generated from enum value: BIDDING_INTRADAY_MARKET_AREA_GROUP_HOKKAIDO = 1;
   */
  HOKKAIDO = 1,

  /**
   * 東北・東京。
   *
   * @generated from enum value: BIDDING_INTRADAY_MARKET_AREA_GROUP_TOHOKU_TOKYO = 2;
   */
  TOHOKU_TOKYO = 2,

  /**
   * 中部・北陸・関西。
   *
   * @generated from enum value: BIDDING_INTRADAY_MARKET_AREA_GROUP_CHUBU_HOKURIKU_KANSAI = 3;
   */
  CHUBU_HOKURIKU_KANSAI = 3,

  /**
   * 中国・四国。
   *
   * @generated from enum value: BIDDING_INTRADAY_MARKET_AREA_GROUP_CHUGOKU_SHIKOKU = 4;
   */
  CHUGOKU_SHIKOKU = 4,

  /**
   * 九州。
   *
   * @generated from enum value: BIDDING_INTRADAY_MARKET_AREA_GROUP_KYUSHU = 5;
   */
  KYUSHU = 5,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayMarketAreaGroup.
 */
export const BiddingIntradayMarketAreaGroupSchema: GenEnum<BiddingIntradayMarketAreaGroup> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_market_model, 0);

/**
 * 時間前市場の取引中断状態 (BFF mirror)。
 * backend `internalapi.v1.IntradayMarketSuspenseState` と 1:1。
 *
 * @generated from enum bffuser.v1.BiddingIntradayMarketSuspenseState
 */
export enum BiddingIntradayMarketSuspenseState {
  /**
   * @generated from enum value: BIDDING_INTRADAY_MARKET_SUSPENSE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 取引中 (= 通常状態)。
   *
   * @generated from enum value: BIDDING_INTRADAY_MARKET_SUSPENSE_STATE_UNSUSPENDED = 1;
   */
  UNSUSPENDED = 1,

  /**
   * 取引中断。
   *
   * @generated from enum value: BIDDING_INTRADAY_MARKET_SUSPENSE_STATE_SUSPENDED = 2;
   */
  SUSPENDED = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayMarketSuspenseState.
 */
export const BiddingIntradayMarketSuspenseStateSchema: GenEnum<BiddingIntradayMarketSuspenseState> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_intraday_market_model, 1);

